module.exports = __webpack_public_path__ + "static/media/r82.947351cb.jpg";